// Estado inicial del formulario de corrida — lógica PURA (formulario.test.ts). Tres
// orígenes: defaults del catálogo, lo guardado en localStorage (puede referir a un modelo
// que ya no existe) y una plantilla de "Reutilizar configuración".

import type { ConfigAnalisis, ConfigFormulario, PlantillaCorrida } from './tipos';

export function formularioDefault(config: ConfigAnalisis): ConfigFormulario {
  return {
    etiqueta: '',
    modelo: config.modelos[0]?.id ?? '',
    effort: config.efforts.includes('medium') ? 'medium' : config.efforts[0] ?? '',
    fotos: 'opt',
    prompt: config.prompt_default,
  };
}

/** Modelo/effort que no están en el catálogo vuelven al default; el resto se respeta. */
export function sanearFormulario(cfg: ConfigFormulario, config: ConfigAnalisis): ConfigFormulario {
  const base = formularioDefault(config);
  return {
    ...cfg,
    modelo: config.modelos.some((m) => m.id === cfg.modelo) ? cfg.modelo : base.modelo,
    effort: config.efforts.includes(cfg.effort) ? cfg.effort : base.effort,
  };
}

export function formularioDePlantilla(p: PlantillaCorrida, config: ConfigAnalisis): ConfigFormulario {
  return sanearFormulario(
    {
      etiqueta: p.etiqueta,
      modelo: p.modelo,
      effort: p.effort ?? '',
      fotos: p.fotos_producto,
      prompt: p.prompt.trim() === '' ? config.prompt_default : p.prompt,
    },
    config,
  );
}

export const MAX_ETIQUETA = 120;

/**
 * Renombrar corrida: qué mandar al backend, o null si no hay nada que mandar (vacía,
 * igual a la actual, o más larga que el límite del backend). Compara trimmeado: el
 * backend también trimmea, así que "igual con espacios" sería un request inútil.
 */
export function etiquetaParaGuardar(actual: string, tipeada: string): string | null {
  const nueva = tipeada.trim();
  if (nueva === '' || nueva.length > MAX_ETIQUETA) return null;
  if (nueva === actual.trim()) return null;
  return nueva;
}
